import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function OpenInApp() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const path = searchParams.get("path") || "/home";
  const [showFallback, setShowFallback] = useState(false);

  const openApp = () => {
    window.location.href = `ontiveros://open?path=${encodeURIComponent(path)}`;
  };

  useEffect(() => {
    openApp();
    const timer = setTimeout(() => setShowFallback(true), 1200);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path]);

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", padding: 24 }}>
      <div style={{ textAlign: "center", maxWidth: 420 }}>
        <h5>Abriendo en Ontiveros…</h5>
        {showFallback && (
          <>
            <p>¿No se abrió la aplicación de escritorio?</p>
            <button type="button" className="btn btn-primary me-2" onClick={openApp}>
              Reintentar abrir la app
            </button>
            <button type="button" className="btn btn-link" onClick={() => navigate(path)}>
              Continuar en el navegador
            </button>
          </>
        )}
      </div>
    </div>
  );
}
